import { Link } from 'react-router-dom';

function EmailVerificationBanner({ onOpenAccount }) {
    return (
        <section className="panel panel--warning">
            <div className="verification-banner">
                <div className="verification-banner__content">
                    <strong>Почта не подтверждена.</strong>
                    <span>
                        Для промокодов, рефералок, счетов и API-токенов нужно подтвердить email.
                    </span>
                </div>
                <div className="verification-banner__actions">
                    <Link className="button-link" to="/verify-email/request">
                        Отправить письмо повторно
                    </Link>
                    <button type="button" className="button-link button-link--button" onClick={onOpenAccount}>
                        Профиль
                    </button>
                </div>
            </div>
        </section>
    );
}

export default EmailVerificationBanner;
